var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"facebook"},[_c('div',{style:({ background: _vm.color })}),_c('div',{style:({ background: _vm.color })}),_c('div',{style:({ background: _vm.color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }